export const USER_SUSPENDED_PATH_SERVICE =
  '/services/payway/paymentservice/v1/usersuspended';
export const PROMO_GATE_PATH_SERVICE =
  '/services/payway/paymentservice/promogate';
export const PURCHASE_BUTTON_INFO_SERVICE = 
'/services/payway/v2/purchasebuttoninfo';
export const PAYWAY_PROFILE_PATH_SERVICE = 
'/services/payway/paymentservice/v1/profile';